module.exports = __webpack_public_path__ + "static/media/ex15.8fa782cc.jpg";